import axios, {AxiosError} from "axios"

const GENERIC_ERROR_MESSAGE = "Something went wrong while processing the request. Please try again later";

export type ValidationError = {
    id?: string;
    message?: string;
    fieldName?: string;
    messageArgs?: unknown[];
    invalidValue?: unknown;
}


function extractValidationMessage(data: unknown): string | null {
    if (!Array.isArray(data)) return null;

    const rawMsg = (data as ValidationError[])?.[0]?.message
    if (typeof rawMsg !== "string") return null;

    const msg = rawMsg.trim();
    if (msg.length === 0) return null;

    if (msg.toLowerCase().includes("missing: apikey")) {
        return "ERP API Key is required.";
    }
    if (msg.toLowerCase().includes("invalid: apikey")) {
        return "The ERP API Key is not valid. Please contact your ERP administrator.";
    }
    return msg;
}

export function getApiKeyErrorMessage(error: unknown): string {
    if (!axios.isAxiosError(error)) return GENERIC_ERROR_MESSAGE;

    const err = error as AxiosError<unknown>;
    const status= err.response?.status;
    const data = err.response?.data;

    if (status === 400) {
        return extractValidationMessage(data) ?? GENERIC_ERROR_MESSAGE;
    }
    return GENERIC_ERROR_MESSAGE;
}